import React, { useEffect, useRef, useState } from 'react';
import '../style/components/rangeSlider.css'; // Add basic CSS for styling

const RangeSlider = ({ initialMin=0, initialMax=100, min = 0, max = 100, step = 1, width="300px", onChange, onChangeDelay=500, showTooltipOnlyOnDrag=false, label="" }) => {
    const [minVal, setMinVal] = useState(initialMin)
    const [maxVal, setMaxVal] = useState(initialMax)
    const [dragging, setDragging] = useState(false)
    const [isFirstRender, setIsFirstRender] = useState(true)
    const sliderTrackRef = useRef(null)
    const tooltipMinRef = useRef(null)
    const tooltipMaxRef = useRef(null)


    const setSliderTrack = () => {
        const range = sliderTrackRef.current
        const minTooltip = tooltipMinRef.current;
        const maxTooltip = tooltipMaxRef.current;
        if (range && minTooltip && maxTooltip) {
            const minPercent =
            ((minVal - min) / (max - min)) * 100;
            const maxPercent =
            ((maxVal - min) / (max - min)) * 100;
            range.style.left = `${minPercent}%`;
            range.style.right = `${100 - maxPercent}%`;
            minTooltip.style.left = `${minPercent}%`;
            maxTooltip.style.right = `${100 - maxPercent}%`;
        }
    };
    const slideMin = (e) => {
        const value = parseFloat(e.target.value);
        if (value >= min && maxVal - value >= step) {
          setMinVal(value);
        }
      };
    
    const slideMax = (e) => {
        const value = parseFloat(e.target.value);
        if (value <= max && value - minVal >= step) {
          setMaxVal(value);
        }
    };
    const startDrag = () => setDragging(true)
    const endDrag = () => setDragging(false)
    useEffect(() => setIsFirstRender(false), [])
    useEffect(() => {
        setSliderTrack();
        let timeout
        if(!isFirstRender) {
            timeout = setTimeout(() => {
                onChange([minVal, maxVal])
            }, onChangeDelay)
        }
        return () => clearTimeout(timeout)
    }, [minVal, maxVal]);
    return (
        <div className='range-slider-container' style={{width: width}}>
            <div className='range-slider'>
                <div ref={sliderTrackRef} className='slider-track'></div>
                <input type='range' className="min-val" min={min} max={max} value={minVal} step={step} onChange={slideMin} onMouseDown={startDrag} onMouseUp={endDrag} onTouchStart={startDrag} onTouchEnd={endDrag}/>
                <input type='range' className="max-val" min={min} max={max} value={maxVal} step={step} onChange={slideMax} onMouseDown={startDrag} onMouseUp={endDrag} onTouchStart={startDrag} onTouchEnd={endDrag}/>
                <div ref={tooltipMinRef} className={`min-tooltip ${dragging && showTooltipOnlyOnDrag || !showTooltipOnlyOnDrag ? "": "d-none"}`}>{minVal}</div>
                <div ref={tooltipMaxRef} className={`max-tooltip ${dragging && showTooltipOnlyOnDrag || !showTooltipOnlyOnDrag ? "": "d-none"}`}>{maxVal}</div>
                <span className="label">{label}</span>
            </div>
        </div>
    )

};

export default RangeSlider;
